import { Box, styled } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AddButton, Toolbox } from 'redesign';
import { useDebounce } from 'shared/hooks/use-debounce';
import { SearchInput } from 'shared/components/search-input';
import { PartnersFilterParams, SetPartnersFilterParams } from '../../partners.types';

export const PartnerFilterToolbox = ({
  params,
  setParams,
}: {
  params: PartnersFilterParams;
  setParams: SetPartnersFilterParams;
}) => {
  const [searchFilter, setSearchFilter] = useState<string | undefined>(params.searchFilter);
  const debouncedSearchFilter = useDebounce(searchFilter, 300);
  const { t } = useTranslation(['hq-screen-specific', 'web-common']);

  useEffect(() => {
    setParams({ searchFilter: debouncedSearchFilter ?? undefined });
  }, [debouncedSearchFilter]);

  return (
    <Toolbox>
      <FiltersContainer>
        <Box flex={1}>
          <AddButton>{t('partners.filter.add_partner')}</AddButton>
        </Box>
        <Box flex={1}>
          <SearchInput
            value={searchFilter}
            onChange={setSearchFilter}
            placeholder={t('partners.filter.search_placeholder', { ns: 'hq-screen-specific' })}
            label={t('buttons.search', { ns: 'web-common' })}
            enableKeyboardShortcut={true}
          />
        </Box>
      </FiltersContainer>
    </Toolbox>
  );
};

const FiltersContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(6),
}));
